import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect, useRef} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import { Search } from "@mui/icons-material";
import { IconButton} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';
import ListDomisiliKokas from './ListDomisiliKokas'
export default function DokKokas({currPreview}){
  const [tanggalSurat, setTanggalSurat]= useState(new Date())
  const [tanggalMulaiDomisili,setTanggalMulaiDomisili] = useState(new Date(currPreview.TanggalMulai))
  const [durasiDomisili, setDurasiDomisili] = useState(1);
  const handleDateChange = (date) => {
    setTanggalSurat(date);
    const piDate = date.getDate();
    const longMonth = date.toLocaleString('default', { month: 'long' });
    const piYear = date.getFullYear();
    console.log(piDate + " " + longMonth + " " + piYear);
}
const handleMulaiDomisiliDateChange = (date) => {
  setTanggalMulaiDomisili(date);
  const piDate = date.getDate();
  const longMonth = date.toLocaleString('default', { month: 'long' });
  const piYear = date.getFullYear();
  console.log(piDate + " " + longMonth + " " + piYear);
}

const downloadDokumenPengajuan = (event) => {
  //Download Dok KTP NPWP Klien
  axios.get(`${process.env.REACT_APP_BACKEND_URL}/KlienProfile?thisClient=${currPreview.KlienID}`, {
  }).then((response) => {
    const ktpKey = response.data.data[0].ktpKey?? "";
    const npwpKey = response.data.data[0].npwpKey?? "";
    console.log(response.data.data[0].npwpKey?? "NPWP Tidak ada Upload")
    console.log(response.data.data[0].ktpKey?? "KTP Tidak ada Upload" )
    //KTP Key
    if(ktpKey){
      if (Array.isArray(ktpKey)) {
        ktpKey.forEach(filename => {
          console.log(filename)
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                responseType: 'blob' // Tell axios to get the response as a blob
            })
            .then((response) => {
              const contentType = response.headers['content-type'];
              console.log(response);
              console.log(response.headers)
              console.log(contentType)
              if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                const blob = new Blob([response.data], { type: contentType });
                const url = URL.createObjectURL(blob);
                window.open(url);
            } else {
                // For other file types, download the file
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([response.data]));
                link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                document.body.appendChild(link);
                link.click();
            }
            })
            .catch((error) => {
                console.log('Error fetching the file:', error);
            });
        });
    } else {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${ktpKey}`, {
        responseType: 'blob' // Tell axios to get the response as a blob
    })
    .then((response) => {
      const contentType = response.headers['content-type'];
      console.log(response);
      console.log(response.headers)
      console.log(contentType)
      if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf'].includes(contentType)) {
        // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);
        window.open(url);
    } else {
        // For other file types, download the file
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data]));
        link.setAttribute('download', 'file'); // Modify the filename and extension as needed
        document.body.appendChild(link);
        link.click();
    }
    })
    .catch((error) => {
        console.log('Error fetching the file:', error);
    });
    }
    }

          //KTP Key End
  
          //NPWP Key
    if(npwpKey){
      if (Array.isArray(npwpKey)) {
        npwpKey.forEach(filename => {
          console.log(filename)
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                responseType: 'blob' // Tell axios to get the response as a blob
            })
            .then((response) => {
              const contentType = response.headers['content-type'];
              console.log(response);
              console.log(response.headers)
              console.log(contentType)
              if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                const blob = new Blob([response.data], { type: contentType });
                const url = URL.createObjectURL(blob);
                window.open(url);
            } else {
                // For other file types, download the file
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([response.data]));
                link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                document.body.appendChild(link);
                link.click();
            }
            })
            .catch((error) => {
                console.log('Error fetching the file:', error);
            });
        });
    } else {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${npwpKey}`, {
        responseType: 'blob' // Tell axios to get the response as a blob
    })
    .then((response) => {
      const contentType = response.headers['content-type'];
      console.log(response);
      console.log(response.headers)
      console.log(contentType)
      if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf'].includes(contentType)) {
        // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);
        window.open(url);
    } else {
        // For other file types, download the file
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data]));
        link.setAttribute('download', 'file'); // Modify the filename and extension as needed
        document.body.appendChild(link);
        link.click();
    }
    })
    .catch((error) => {
        console.log('Error fetching the file:', error);
    });
    }
    }

          //NPWP Key End
  })
  .catch((error) => {
    console.error('There was an error!', error);
  });
  //End Download Doc KTP NPWP Klien

  //Start Surat Permohonan
  try {
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/suratPermohonanDomisiliVOfromDB`,{
        id: currPreview._id, tanggalMulaiDomisili, durasiDomisili, tanggalSurat
    },{
        responseType: "blob" 
    }).then(resp => {
        console.log(resp)
            const blob = new Blob([resp.data], { type: 'application/pdf' })
        // saveAs(blob);
        var fileURLNew = URL.createObjectURL(blob);
        console.log(fileURLNew)
        window.open(fileURLNew, '_blank');
    })
  } catch (error) {
    console.error(error);
  } finally {
  }

  //End Surat Permohonan

  //Start Kontrak untuk Domisili
    try {
            axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakDomisiliVOfromDB`,{
                id: currPreview._id, tanggalMulaiDomisili, durasiDomisili
            },{
                responseType: "blob" 
            }).then(resp => {
                console.log(resp)
                    const blob = new Blob([resp.data], { type: 'application/pdf' })
                // saveAs(blob);
                var fileURLNew = URL.createObjectURL(blob);
                console.log(fileURLNew)
                window.open(fileURLNew, '_blank');
            })
          } catch (error) {
            console.error(error);
          } finally {
          }
  //End Kontrak untuk Domisili
}
const [uploadDomisiliOpen,setUploadDomisiliOpen] = useState(false);
const uploadDomisili = () => {
  setUploadDomisiliOpen(true)
  console.log(currPreview)
}
const closesetUploadDomisiliOpen = () => {
  setUploadDomisiliOpen(false)
}
    return <Grid sx={{m:2}}>
    <Dialog open={uploadDomisiliOpen} onClose={closesetUploadDomisiliOpen}>
      <ListDomisiliKokas currPreview={currPreview}></ListDomisiliKokas>
      </Dialog>
        <Grid container sx={{mt:2, mb:2}}>
        
                            
          <Grid item xs={5} sx={{mt:1}}><Typography variant="h6">Tanggal Surat :</Typography></Grid>
             <Grid item xs={7}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>

                  <MobileDatePicker 
                    views={['year', 'month', 'day']}
                    inputFormat="dd/MM/yyyy"
                    value={tanggalSurat}
                    onChange={handleDateChange}
                    renderInput={(params) => 
                      <TextField 
                          {...params} 
                          InputProps={{
                            endAdornment: (
                              <InputAdornment >
                                <CalendarMonthIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                    }
                  />

                </LocalizationProvider>

        </Grid>
      </Grid>

      <Grid container sx={{mt:2, mb:2}}>
                            
                            <Grid item xs={5} sx={{mt:1}}><Typography variant="h6">Mulai Domisili :</Typography></Grid>
                               <Grid item xs={7}>
                                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                  
                                    <MobileDatePicker 
                                      views={['year', 'month', 'day']}
                                      inputFormat="dd/MM/yyyy"
                                      value={tanggalMulaiDomisili}
                                      onChange={handleMulaiDomisiliDateChange}
                                      renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                              endAdornment: (
                                                <InputAdornment >
                                                  <CalendarMonthIcon />
                                                </InputAdornment>
                                              ),
                                            }}
                                          />
                                      }
                                    />
                  
                                  </LocalizationProvider>
                  
                          </Grid>
                        </Grid>
    <Grid xs={12} sx={{mt:2, mb:2}} container>
        <Grid item xs={5}>
        <Typography variant="h6" sx={{mt:1}}>Durasi Domisili :</Typography>
        </Grid>
        <Grid item xs={6.9}>
              <TextField value={durasiDomisili} type="number" InputProps={{
          endAdornment: <InputAdornment position="end">Tahun</InputAdornment>,
        }} onChange={event=> setDurasiDomisili(event.target.value)}></TextField>
        </Grid>
        
    </Grid>
    <Grid xs={12} sx={{mt:2, mb:2}}>
        <Button variant="contained" onClick={downloadDokumenPengajuan}>Dokumen Pengajuan</Button>
        <Button variant="contained" color="success" onClick={uploadDomisili}>Lihat Domisili Upload</Button>
    </Grid>

    </Grid>
}